import React from 'react';
import ReactPlayer from 'react-player';
import { PlayCircle, Volume2 } from 'lucide-react';

export default function TestVideoPlayer() {
  // Test data matching the expected lesson structure
  const testLesson = {
    id: "686f7649-9d57-41c8-a4ce-3b4543cf29ec",
    title: "TEST VIDEO",
    video_url: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
    audio_url: "https://example.com/audio.mp3",
    content: "This is a test lesson to verify YouTube video display functionality."
  };

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-8 text-center">
          YouTube Video Player Test - {testLesson.title}
        </h1>
        
        <div className="bg-white rounded-lg shadow-lg p-6 space-y-6">
          {/* Lesson Content */}
          <div>
            <h2 className="text-xl font-semibold mb-3">Lesson Content</h2>
            <p className="text-gray-700">{testLesson.content}</p>
          </div>

          {/* Video Player */}
          {testLesson.video_url && (
            <div>
              <div className="flex items-center gap-2 mb-3">
                <PlayCircle className="w-5 h-5" style={{ color: '#102862' }} />
                <h3 className="text-lg font-semibold">Video Content</h3>
              </div>
              <div className="relative aspect-video bg-black rounded-lg overflow-hidden">
                <ReactPlayer
                  url={testLesson.video_url}
                  width="100%"
                  height="100%"
                  controls
                />
              </div>
              <p className="text-sm text-gray-600 mt-2">
                Video URL: {testLesson.video_url}
              </p>
            </div>
          )}

          {/* Audio Player */}
          {testLesson.audio_url && (
            <div>
              <div className="flex items-center gap-2 mb-3">
                <Volume2 className="w-5 h-5" style={{ color: '#102862' }} />
                <h3 className="text-lg font-semibold">Audio Content</h3>
              </div>
              <div className="bg-slate-50 rounded-lg p-6">
                <ReactPlayer
                  url={testLesson.audio_url}
                  width="100%"
                  height="60px"
                  controls
                />
              </div>
              <p className="text-sm text-gray-600 mt-2">
                Audio URL: {testLesson.audio_url}
              </p>
            </div>
          )}

          {/* Test Information */}
          <div className="bg-blue-50 p-4 rounded-lg">
            <h3 className="font-semibold text-blue-900 mb-2">Test Information</h3>
            <ul className="text-sm text-blue-800 space-y-1">
              <li>• Course ID: 850783f3-8265-41ba-bab5-09fc966143b5 (Coronectomy)</li>
              <li>• Lesson ID: {testLesson.id}</li>
              <li>• Expected Video ID: dQw4w9WgXcQ</li>
              <li>• ReactPlayer should create YouTube iframe</li>
              <li>• Video should be in 16:9 aspect ratio container</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}